import React, { Component } from "react";
import { Button, Icon } from "react-materialize";
import TableGrid from "./TableGrid";
import ThumbnailsGrid from "./ThumbnailsGrid";
import EventUtils from "../../utils/EventUtils";
import CommonConstants from "../../constants/CommonConstants";
import "./Grid.css";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import ConfigurationManager from "../../configuration/ConfigurationManager";
import DialogBox from "../dialogeBox/DialogBox";

class Grid extends Component {
  static DISPLAY_MODE_TABLE = 0;
  static DISPLAY_MODE_THUMBNAIL_GRID = 1;

  constructor(props) {
    super(props);
    ConfigurationManager.environment = process.env;
    const { displayMode } = props;

    this.state = {
      displayMode: displayMode ? displayMode : Grid.DISPLAY_MODE_TABLE,
      selected: [],
      alert: false,
      mailMesaage: false,
      confirmMessage: true,
      dateSelect: false,
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
      openSnackMsg: false,
      snackBarMsg: "",
      searchTerm: null,
      currentUserEmail: null,
      alertMessage: null,
      loading: false,
    };

    this.displayThumbnailGrid = this.displayThumbnailGrid.bind(this);
    this.displayTable = this.displayTable.bind(this);
    this._handleSelect = this._handleSelect.bind(this);
    this._handleSelectAllClick = this._handleSelectAllClick.bind(this);
    this._handleAddToCartClick = this._handleAddToCartClick.bind(this);
    this._handleClose = this._handleClose.bind(this);
    this._handleSnackMsgClose = this._handleSnackMsgClose.bind(this);
    this._handleSnackBarMessageDisplay = this._handleSnackBarMessageDisplay.bind(
      this
    );
  }

  get selected() {
    return this.state.selected;
  }

  set selected(selected) {
    this.setState({ selected: selected });
  }

  get displayMode() {
    return this.state.displayMode;
  }

  set displayMode(displayMode) {
    this.setState({ displayMode: displayMode });
  }

  displayThumbnailGrid() {
    this.setState({ displayMode: Grid.DISPLAY_MODE_THUMBNAIL_GRID });
  }

  displayTable() {
    this.setState({ displayMode: Grid.DISPLAY_MODE_TABLE });
  }

  _handleSelect(event) {
    let detail = event.detail;
    if (detail.selected) {
      let selected = this.selected;
      if (selected) selected.push(detail.id);

      this.selected = selected;
    } else {
      this.selected = this.selected.filter((x) => x !== detail.id);
    }
  }

  _handleSelectAllClick(event) {
    this.setState({ alert: true });
  }

  _handleAddToCartClick(event) {
    const { selected } = this.state;
    const { entries } = this.props;

    if (selected.length > 100) {
      this.setState({
        openSnackMsg: true,
        snackBarMsg: "Please apply bulk report generation",
      });
      return;
    }

    let entriesToAdd = [];
    for (let i = 0; i < selected.length; i++) {
      let entry = entries[selected[i]];

      if (entry) {
        if (entry.type === CommonConstants.ACTIVE_ASSETS_FILE_TYPE) {
          //Adding Source Application to Live Assets
          entry.properties["live_file:sourceApplication"] = "STAR LABS";
        }
        entriesToAdd.push(entry);
      }
    }

    EventUtils.raiseEvent("add-to-cart", { items: entriesToAdd }, this.props);
  }

  _handleClose(event) {
    this.setState({
      alert: false,
    });
  }

  // async _handleDateContinue(event) {
  //   this.setState({ loading: true });
  //   let startDate = new Date(this.state.startDate);
  //   let endDate = new Date(this.state.endDate);
  //   let presentDate = new Date();
  //   if (startDate > presentDate || endDate > presentDate) {
  //     this.setState({
  //       loading: false,
  //       openSnackMsg: true,
  //       snackBarMsg: `Dates cannot be greater present date.`,
  //     });
  //     return;
  //   } else if (startDate > endDate) {
  //     this.setState({
  //       loading: false,
  //       openSnackMsg: true,
  //       snackBarMsg: "End Date should be greater than Start Date",
  //     });
  //     return;
  //   } else {
  //     let REQUEST_URL =
  //       "https://ytadocztq7.execute-api.us-west-2.amazonaws.com/QA/qa";
  //     let data = {
  //       email: this.state.currentUserEmail,
  //       filters: this.state.searchTerm,
  //       startDate: this.state.startDate,
  //       endDate: this.state.endDate,
  //     };
  //     let myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  //     let raw = JSON.stringify(data);
  //     let requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };
  //     await fetch(REQUEST_URL, requestOptions).then((response) => {
  //       if (response.status !== 200) {
  //         this.setState({
  //           loading: false,
  //           alertMessage: "Something went wrong. Please try after sometime!",
  //           dateSelect: false,
  //           mailMesaage: true,
  //         });
  //       } else {
  //         this.setState({
  //           loading: false,
  //           alertMessage: "You will receive Asset Report on your mail!",
  //           dateSelect: false,
  //           mailMesaage: true,
  //         });
  //       }
  //     });
  //   }
  // }

  _handleSnackBarMessageDisplay(message) {
    this.setState({
      loading: false,
      openSnackMsg: true,
      snackBarMsg: message,
    });
  }

  _handleSnackMsgClose(event) {
    this.setState({ openSnackMsg: false });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.entries !== this.props.entries) {
      this.selected = [];
    }

    if (props.displayMode !== this.props.displayMode) {
      this.displayMode = props.displayMode;
    }
    if (props.searchTerm !== this.state.searchTerm) {
      this.setState({ searchTerm: props.searchTerm });
    }
    if (props.currentUser !== null) {
      this.setState({
        currentUserEmail: props.currentUser.properties.email,
      });
    }
  }

  render() {
    const { displayMode, selected } = this.state;
    const {
      totalCount,
      entries,
      tableColumns,
      thumbnailMapper,
      hidden,
    } = this.props;
    return (
      <>
        <DialogBox
          alert={this.state.alert}
          totalCount={totalCount}
          searchTerm={this.state.searchTerm}
          _handleClose={this._handleClose}
          _handleSnackBarMessageDisplay={this._handleSnackBarMessageDisplay}
          currentUserEmail={this.state.currentUserEmail}
          selectedAssets={null}
        />
        <div className="grid" hidden={hidden}>
          <div className="grid-toolbar">
            <label>{totalCount} entries found.</label>
            <Button
              floating
              className={
                displayMode === Grid.DISPLAY_MODE_THUMBNAIL_GRID
                  ? "grid-btn active"
                  : "grid-btn"
              }
              waves="teal"
              tooltip="Show as Thumbnails"
              onClick={this.displayThumbnailGrid}>
              <Icon tiny>view_module</Icon>
            </Button>
            <Button
              floating
              className={
                displayMode === Grid.DISPLAY_MODE_TABLE
                  ? "grid-btn active"
                  : "grid-btn"
              }
              waves="teal"
              tooltip="Show as Table"
              onClick={this.displayTable}>
              <Icon tiny>list_view</Icon>
            </Button>
            <Button
              floating
              className="grid-btn"
              waves="teal"
              tooltip="RUN REPORT FOR ALL ASSETS"
              onClick={this._handleSelectAllClick}
              style={entries.length === 0 ? { display: "none" } : {}}>
              {/* <Icon tiny>select_all</Icon> */}
              <Icon tiny>donut_small</Icon>
            </Button>
            <Button
              floating
              className="grid-btn"
              waves="teal"
              tooltip="Add To Cart"
              onClick={this._handleAddToCartClick}
              style={
                entries.length === 0 || selected.length === 0
                  ? { display: "none" }
                  : {}
              }>
              <Icon tiny>add_shopping_cart</Icon>
            </Button>
          </div>
          <TableGrid
            columns={tableColumns}
            entries={entries}
            selected={selected}
            hidden={displayMode !== Grid.DISPLAY_MODE_TABLE}
            onScrollBottom={this.props.onScrollBottom}
            onSelect={this._handleSelect}
          />
          <ThumbnailsGrid
            thumbnailMapper={thumbnailMapper}
            entries={entries}
            selected={selected}
            hidden={displayMode !== Grid.DISPLAY_MODE_THUMBNAIL_GRID}
            onScrollBottom={this.props.onScrollBottom}
            onSelect={this._handleSelect}
          />
        </div>
        <div className="snack-bar-container">
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={this.state.openSnackMsg}
            onClose={this._handleSnackMsgClose}
            autoHideDuration={6000}
            ContentProps={{ "aria-describedby": "snack-bar-msg" }}
            message={
              <div className="snack-bar-msg-content">
                <span className="snack-bar-msg-icon">
                  <InfoIcon />
                </span>
                <span className="snack-bar-msg">{this.state.snackBarMsg}</span>
              </div>
            }
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                className="snack-msg-close-icon"
                onClick={this._handleSnackMsgClose}>
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </div>
      </>
    );
  }
}

export default Grid;
